import React from 'react'
import './admin-applications.css'
import ApplicationCard from '../ApplicationCard/ApplicationCard'
import ApplicationModal from '../ApplicationModal/ApplicationModal'
import {ErrorPopup} from '../ErrorPopup/ErrorPopup'
import NewLoadingScreen from '../NewLoadingScreen/NewLoadingScreen'
import { baseUrl } from '../assets/Animations'
import loadingping from '../img/loadingpin.svg'
import useFetch from '../hooks/useFetch'
import { createPostInterviewTask, createTeacherOnboardingWorkflow, createTeacherOffboardingWorkflow } from '../AdminWorkflows/WorkflowModels'
import WorkflowChip2023 from '../AdminTasks/WorkflowChip2023/WorkflowChip2023'
import OnboardingCardModal2023 from '../OnboardingCardModal2023/OnboardingCardModal2023'
import ApplicationModal2024 from '../ApplicationModal2024/ApplicationModal2024'

const AdminApplications = (props) => {
    const [openWorkflowModal2023, setOpenWorkflowModal2023] = React.useState(false)
    const [application, setApplication] = React.useState(false)
    const [error, setError] = React.useState(false)
    const [loadingScreen, setLoadingScreen] = React.useState(false)
    const [loadingMessage, setLoadingMessage] = React.useState('')
    const {data: workflows, loading: gettingWorkflows, error: testError, reFetch, callPut, callDelete, pushItem, updateItem, deleteItem} = useFetch(`${baseUrl}/onboarding`)

    const isManager = props.userData.PermissionLevel === 'manager' && props.userData.IsAdmin

    React.useEffect(() => {
        props.getApplications();
    }, [])

    const sameSchool = (app) => {
        return app.key14app === changeAbbreviationToSchoolName(props.userData.School)
    }

    const changeAbbreviationToSchoolName = (abbreviation) => {
        switch(abbreviation) {
            default: return ''
            case 'mma': return 'Mountainside Music Academy'
            case 'lsma': return 'Lakeside Music Academy'
            case 'tma': return 'Treeside Music Academy'
            case 'mor': return 'Morningside Music Academy'
            case 'psma': return 'Parkside Music Academy'
        }
    }

    const deleteApplication = async (id) => {
        callDelete(`${baseUrl}/applications/${id}`, props.removeApplication(id), 'id')
        setApplication(false)
        setLoadingScreen(false)
    }

    const toggleLoadingScreen = (message) => {
        if(loadingMessage !== '') {
            setLoadingMessage('') 
            setLoadingScreen(false)
        } else {
            setLoadingMessage(message)
            setLoadingScreen(true)
        }
    }

    return (
        <div className="admin-task-page">
            {loadingScreen && <NewLoadingScreen message={loadingMessage} />}
            <div className="admin-applications__column">
                <div className="admin-applications__column__header">
                    <div className="admin-applications__column__title">Applications</div>
                </div>
                <div className="admin-applications__column__scroll-area">
                    {props.applications?.map(app => 
                        isManager ? 
                        sameSchool(app) && <ApplicationCard key={app.id} toggleApplication={setApplication} application={app} />
                        :
                        <ApplicationCard key={app.id} toggleApplication={setApplication} application={app} />)}
                </div>
            </div>
            <div className="admin-applications__column">
                <div className="admin-applications__column__header">
                    <div className="admin-applications__column__title">Interviews</div>
                    <div className="admin-applications__column__btn" onClick={() => createPostInterviewTask('First', 'Last', 'None', 'SCHOOL', [], pushItem)}>+ Add Interview</div>
                </div>
                <div className="admin-applications__column__scroll-area">
                {gettingWorkflows ? <img className="loading-ping" src={loadingping} />
                    :
                    <div>
                        {workflows?.map(workflow => 
                        isManager ?
                        workflow.whichList === 'move-forward' && props.userData.School === workflow.whichSchool && <WorkflowChip2023 key={workflow.todoId} workflow={workflow} setOpenWorkflowModal2023={setOpenWorkflowModal2023} getNotesAboutModal={props.getNotesAboutModal} />
                        : 
                        workflow.whichList === 'move-forward' && <WorkflowChip2023 key={workflow.todoId} workflow={workflow} setOpenWorkflowModal2023={setOpenWorkflowModal2023} getNotesAboutModal={props.getNotesAboutModal} />)}
                    </div>
                }
                </div>
            </div>
            <div className="admin-applications__column">
                <div className="admin-applications__column__header">
                    <div className="admin-applications__column__title">Onboarding</div>
                    <div className="admin-applications__column__btn" onClick={() => createTeacherOnboardingWorkflow(setLoadingScreen, pushItem, setOpenWorkflowModal2023)}>+ Onboard Teacher</div>
                </div>
                <div className="admin-applications__column__scroll-area">
                {gettingWorkflows ? <img className="loading-ping" src={loadingping} />
                    :
                    <div>
                    {workflows.map(workflow => 
                    isManager ?
                        workflow.whichList === 'teacher' && props.userData.School === workflow.whichSchool && <WorkflowChip2023 key={workflow.todoId} workflow={workflow} setOpenWorkflowModal2023={setOpenWorkflowModal2023} getNotesAboutModal={props.getNotesAboutModal} />
                    : 
                        workflow.whichList === 'teacher' && <WorkflowChip2023 key={workflow.todoId} workflow={workflow} setOpenWorkflowModal2023={setOpenWorkflowModal2023} getNotesAboutModal={props.getNotesAboutModal} />)}
                    </div>}
                </div>
            </div>
            <div className="admin-applications__column">
                <div className="admin-applications__column__header">
                    <div className="admin-applications__column__title">Offboarding</div>
                    <div className="admin-applications__column__btn" onClick={() => createTeacherOffboardingWorkflow(setLoadingScreen, pushItem, setOpenWorkflowModal2023)}>+ Offboard Teacher</div>
                </div>
                <div className="admin-applications__column__scroll-area">
                {gettingWorkflows ? <img className="loading-ping" src={loadingping} />
                    :
                    <div>
                    {workflows.map(workflow => workflow.whichList === 'teacher-offboarding' &&
                    isManager ?
                    workflow.whichList === 'teacher-offboarding' && props.userData.School === workflow.whichSchool && <WorkflowChip2023 key={workflow.todoId} workflow={workflow} setOpenWorkflowModal2023={setOpenWorkflowModal2023} getNotesAboutModal={props.getNotesAboutModal} />
                    : 
                    workflow.whichList === 'teacher-offboarding' && <WorkflowChip2023 key={workflow.todoId} workflow={workflow} setOpenWorkflowModal2023={setOpenWorkflowModal2023} getNotesAboutModal={props.getNotesAboutModal} />)}
                    </div>}
                </div>
            </div>
            {application && <ApplicationModal2024 setApplication={setApplication} application={application} deleteApplication={deleteApplication} toggleLoadingScreen={toggleLoadingScreen} setError={setError} pushItem={pushItem} />}
            {/* {application && <ApplicationModal setApplication={setApplication} application={application} deleteApplication={deleteApplication} toggleLoadingScreen={toggleLoadingScreen} setError={setError} pushItem={pushItem}/>} */}
            {openWorkflowModal2023 && <OnboardingCardModal2023 openWorkflowModal2023={openWorkflowModal2023} setOpenWorkflowModal2023={setOpenWorkflowModal2023} setShowNotes={props.setShowNotes} updateItem={updateItem} deleteItem={deleteItem} />}
            {error && <ErrorPopup error={error} setError={setError}/>}
        </div>
    )
}

export default AdminApplications